import { useCallback, useEffect, useState } from 'react';
type BreakPoints = Record<number, number> | Array<number | undefined>;
type BreakPointsArray = Array<number | undefined>;
type BreakPointSpec = BreakPoints | BreakPointsArray;
type Columns = number | BreakPointSpec;

const useColumnCount = (columns?: Columns): number => {
  const [columnCount, setColumnCount] = useState(1);

  const handleResize = useCallback(() => {
    if (typeof columns === 'object') {
      let count = 1; // Default fallback value
      const sortedColumns = Object.keys(columns).sort((a, b) => parseInt(a) - parseInt(b));
      for (const key of sortedColumns) {
        if (window.innerWidth >= parseInt(key)) {
          count = columns[key];
        }
      }
      setColumnCount(count);
    } else {
      setColumnCount(columns);
    }
  }, [columns]);

  useEffect(() => {
    handleResize();
    if (typeof columns === 'object') {
      window.addEventListener('resize', handleResize);
    } else {
      window.removeEventListener('resize', handleResize);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize, columns]);

  return columnCount;
};

export default useColumnCount;